import classnames from 'classnames';
import PropTypes from 'prop-types';

import { useLabelProviderDisplayName } from './use-label-provider-display-name';
import DataDrivenLogo from '../../../../components/data-driven-logo';

import style from './label-provider-logo.module.less';

const LabelProviderLogo = ({ carrierId, className = '', fillProviderId, isDisabled = false, labelProviderId }) => {
  const labelProviderDisplayName = useLabelProviderDisplayName({
    carrierId,
    fillProviderId,
    labelProviderId,
  });

  return (
    <div
      className={classnames(style['label-provider-logo'], className, {
        [style['is-disabled']]: isDisabled,
      })}
    >
      <DataDrivenLogo
        aria-label={labelProviderDisplayName}
        carrierId={Number.parseInt(carrierId, 10)}
        fillProviderId={Number.parseInt(fillProviderId, 10)}
        logoType='icon'
        providerId={Number.parseInt(labelProviderId, 10)}
      />
    </div>
  );
};

export default LabelProviderLogo;

LabelProviderLogo.propTypes = {
  carrierId: PropTypes.string,
  fillProviderId: PropTypes.string,
  isDisabled: PropTypes.bool,
  labelProviderId: PropTypes.string,
  className: PropTypes.string,
};
